import React from 'react';
import moment from 'moment';
import findIndex from 'lodash/findIndex';
import {
	UpdatePropsCancelReasign
} from '../../../../home/helper/request.props.js';

import {
	PresenterCancelReasign
} from '../../../../home/presenter.js'

// TOAST
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import PopoverHelper from 'utils/PopoverHelper';

export default class IncomingMessageRow extends React.Component {
	confirmAction(action) {
		if(action) {			
			this.props.self.toogleModalDueDate(this.props.RowData);
		} else {
			this.props.self.toogleModalReject(this.props.RowData)
		}

	}
	
	confirm(action){
		if(this.props.RowData.NextReservation !== null){
			if (this.props.self.props.UserReducer.username === this.props.RowData.NextReservation.User.Username){
				this.props.self.toggleModalDialogue(this.props.RowData,false)
			}else{
				this.confirmAction(action)
			}
		}else{
			this.confirmAction(action)
		}	
	}

	cancelReasign(data) {
		this.requestParams = {
			Alias : data.Alias 
		}
		PresenterCancelReasign(
			UpdatePropsCancelReasign(this, this.OnCancelSuccsess, this.OnCancelFailed)
		)
	}

	OnCancelSuccsess(params, response) {
		toast.success("Success cancel reasign");
		params.self.props.self.updateRow(response.data);
	}

	OnCancelFailed(params, response) {
		toast.error(response.data.detail)
	}

	renderConfirmation() {
		let responseStatus = this.props.RowData.Response;
		let curentUser = this.props.self.props.UserReducer.username;
		let toUser = this.props.RowData.ToUser;

		if ( responseStatus === "yes" ) {
			return (
				<div className="confirmation">
					<div className="action-confirm">
						<div className="email-accepted">
							<span className="icon-check"></span>&nbsp;Accepted on {moment(this.props.RowData.ResponseTime).format('llll')}
						</div>
					</div>
				</div>
			)
		} else if ( responseStatus === "no" ) {
			return (
				<div className="confirmation">
					<div className="action-confirm">
						<div className="email-rejected">
							<span className="icon-check"></span>&nbsp;Rejected on {moment(this.props.RowData.ResponseTime).format('llll')}
						</div>
					</div>
				</div>
			)
		}else if (responseStatus === "cancel" ){
			return (
				<div className="confirmation">
					<div className="action-confirm">
						<div className="email-canceled">
							<span className="icon-check"></span>&nbsp;Canceled on {moment(this.props.RowData.ResponseTime).format('llll')}
						</div>
					</div>
				</div>
			)
		} else if( curentUser !== toUser ){
			return (
				<div className="confirmation">
					<div className="action-confirm">
						<button onClick={(e)=>{e.stopPropagation(); this.cancelReasign(this.props.RowData)}} type="button" className="btn btn-warning btn-radius"><span className="icon-close"></span>&nbsp;Cancel</button>						
					</div>
				</div>
			)
		} else {
			return (
				<div className="confirmation">
					<div className="action-confirm">
						<button 
							onClick={(e)=>{e.stopPropagation(); this.confirmAction(false)}} 
							type="button"
							disabled={this.props.selected.length > 0}
							className="btn btn-danger btn-radius"><span className="icon-close"></span>&nbsp;Reject</button>
						&nbsp;
						<button 
							onClick={(e)=>{e.stopPropagation(); this.confirm(true)}} 
							type="button"
							disabled={this.props.selected.length > 0}
							className="btn btn-success btn-radius"><span className="icon-check"></span>&nbsp;Accept</button>
					</div>
				</div>
			)
		}
	}

	renderLabelUrgent() {
		const {FlashingDate, Response} = this.props.RowData
		if(Response === null) {
			if(moment(FlashingDate) < moment()) {
				return(<span className="span-urgent">urgent</span>)
			}
		}
	}

	handleChecked = (e) => {
		e.stopPropagation()
		if(e.target.checked) { // checked
			this.props.onChangeBulk(this.props.RowData, this.props.RowData.Alias, true)
		}else if (e.target.checked === false){ // unchecked
			this.props.onChangeBulk(this.props.RowData, this.props.RowData.Alias, false)
		}
	}

	renderCheckBox = () => {
		const {RowData, selected} = this.props
		// const index = selected.findIndex(item => RowData.Alias === item.Alias)
		const index = findIndex(selected, function(item) { return RowData.Alias === item.Alias });
		let curentUser = this.props.self.props.UserReducer.username;
		let flag_checked = false

		if(index > -1) {
			flag_checked = selected[index].Alias === RowData.Alias
		}

		if(RowData.Response === "yes" || RowData.Response === "no" || RowData.Response === "cancel" || curentUser !== RowData.ToUser) {
			return (
				<PopoverHelper 
					id={"id"+RowData.Alias} 
					placement="right"
					mLeft="0"
					content="Sorry this asset is not available for bulk accept or reject."
				/>
			)
		} else {
			return(
				<span className="grey-checkbox">
					<label className="container-checkbox" onClick={this.handleChecked}>
						<input type="checkbox" checked={flag_checked}/>
						<span className="checkmark"></span>
					</label>
				</span>
			)
		}
	}

	render() {
		let unread = this.props.RowData.Response;
		let curentUser = this.props.self.props.UserReducer.username;
		let toUser = this.props.RowData.ToUser;
		return (
			<div className={unread===null ? "message unread" : "message"} onClick={() => this.props.openModalDetail(this.props.RowData.Asset)}>
				<div className="actions">
					<span className="action">{this.renderCheckBox()}</span>
				</div>
				<div className="header">
					{/*OUT*/}
					{ curentUser !== toUser &&
						<div className="from">
							To : <span className="capitalize">{this.props.RowData.ToUser}</span>{this.renderLabelUrgent()}
						</div>
					}
					{/*END OUT*/}
					
					{/*IN*/}
					{ curentUser === toUser &&
						<div className="from">
							From: <span className="capitalize">{this.props.RowData.Accessed.CreatedBy}</span>{this.renderLabelUrgent()}
						</div>
					}
					{/*END IN*/}
					<div className="date">{moment(this.props.RowData.Accessed.CreatedTime).format('llll')}</div>
				</div>
				<div className="title">
					Request Assigned : <span>{this.props.RowData.Asset.Name}</span> ( <span>{this.props.RowData.Asset.Alias}</span> )
				</div>
				{/*OUT*/}
				{ curentUser !== toUser &&
					<div className="description">
						You request to re-assign the&nbsp;
						<span className="bt-dashed">{this.props.RowData.Asset.Name} ( {this.props.RowData.Asset.Alias} )</span>&nbsp;
						to <span className="capitalize bt-dashed">{this.props.RowData.ToUser}</span>. Click cancel to cancel re-assign.
					</div>
				}
				{/*END OUT*/}

				{/*IN*/}
				{ curentUser === toUser &&
					<div className="description">
						<span className="capitalize bt-dashed">{this.props.RowData.Accessed.CreatedBy}</span> request to re-assign the&nbsp;
						<span className="bt-dashed">{this.props.RowData.Asset.Name} ( {this.props.RowData.Asset.Alias} )</span>&nbsp;
						to you. Please click accept or reject to confirm.
					</div>
				}
				{/*END IN*/}

				{/*RESPONSE MESSAGE*/}
				{ this.props.RowData.ResponseMessage != null &&
					<div className="description">
						<b>Response:</b> {this.props.RowData.ResponseMessage}
					</div>
				}
				{/*END RESPONSE MESSAGE*/}
				{this.renderConfirmation()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/IncomingMessage/IncomingMessageRow.js